'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';
import confirmDialog from '@/js/modules/confirm_dialog';

export { flashMessage } from '@/js/modules/admin_flash';

onPageLoad(() => {
  $(document).on('change', 'input[name=debug_search_rank]', (e) => {
    const $form = $(e.currentTarget).parents('form');
    $form.submit();
  });

  $(document).on('change', '.field--change-admin, .green-checkbox--is-retailer', (e) => {
    $(e.target).parents('form').submit();
  });

  $(document).on('submit', '.cancel-stripe-subscription-form', async (e) => {
    e.preventDefault();

    const cancel = await confirmDialog(
      'Cancel paid subscription on Stripe? Designer will have to sign up from scratch with her CC to renew it.'
    );

    if (cancel) {
      e.target.submit();
    }
  });
});
